// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge__TWZrl","logo":"styles_logo__hxAmf","score":"styles_score__P3KEH","score__main":"styles_score__main__jYU2S","score__denom":"styles_score__denom__u4hbj"};